import * as React from 'react';
import { Route } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';
import PromoTemplateApp from 'bundles/promo-template/components/PromoTemplateApp';
import { DOMAINS } from 'bundles/promo-template/constants/navigation';

const DevDomain = loadOnRoute(() => import('bundles/promo-template/pages/DevDomain'));
const ExploreDomain = loadOnRoute(() => import('bundles/promo-template/pages/consumer/ExploreDomain'));
const EnterpriseExploreDomain = loadOnRoute(
  () => import('bundles/promo-template/pages/enterprise/EnterpriseExploreDomain')
);
const EmbeddedPages = loadOnRoute(() => import('bundles/promo-template/pages/EmbeddedPages'));

const AboutDomain = loadOnRoute(() => import('bundles/promo-template/pages/AboutDomain'));
const DegreesDomain = loadOnRoute(() => import('bundles/promo-template/pages/DegreesDomain'));

const HOMEPAGE_SLUG_FOR_DOMAIN = {
  [DOMAINS.about]: 'about-homepage',
};

export default (
  <Route>
    <Route path="/" component={PromoTemplateApp}>
      {/* This is a demo page that lists the embedded promo-template pages that are embedded in other apps */}
      <Route path="promo-template/embedded-pages" getComponent={EmbeddedPages} />
      {/* promoTemplate-testPage is a sample slug */}
      <Route path="promo-template/*" getComponent={DevDomain} />
      {['explore/*', '/google-career-certificates', '/meta-professional-certificates'].map((path) => (
        <CourseraRoute
          key={path}
          handle={{
            tracking: {
              data: () => ({
                page: { type: 'promo_template', segment: 'consumer' },
              }),
            },
          }}
          path={path}
          getComponent={ExploreDomain}
        />
      ))}
      {['about', 'about/*'].map((path) => (
        <CourseraRoute
          key={path}
          handle={{
            tracking: {
              data: () => ({
                page: { type: 'promo_template', segment: 'consumer' },
              }),
            },
            // `about` relies on `slugOverride` for proper routing to the homepage, since
            // "PromoTemplate - Page Content" entries require a slug to be published, and
            // homepages for any domain should not end in a page slug. For reference:
            // https://app.contentful.com/spaces/00atxywtfxvd/entries/3peYTIjqi7u9jVSgtfej1p
            slugOverride: path === 'about' ? HOMEPAGE_SLUG_FOR_DOMAIN[DOMAINS.about] : undefined,
          }}
          path={path}
          getComponent={AboutDomain}
        />
      ))}
      <CourseraRoute
        handle={{
          tracking: {
            data: () => ({
              page: { type: 'promo_template', segment: 'consumer' },
            }),
          },
        }}
        path="degrees/*"
        getComponent={DegreesDomain}
      />
      <CourseraRoute
        handle={{
          tracking: {
            data: (params) => ({
              page: { type: 'promo_template', segment: 'enterprise' },
              enterprise: {
                ...(params?.programSlug ? { programSlug: params.programSlug } : {}),
              },
            }),
          },
        }}
        path="programs/:programSlug/explore/:pageSlug"
        getComponent={EnterpriseExploreDomain}
      />
    </Route>
    <Route path="*" component={NotFound} />
  </Route>
);
